import React from 'react';
import {UeLink} from '../../wraps';
import styled from 'styled-components';
import {LinkProps} from '../../../types';
import {AccentColorOptions} from 'epic-ue-theme';

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

interface Props {
    accentColor: AccentColorOptions;
    accentColorDark?: boolean;
}

const HyperlinkWrapper = styled.span<Props>`
    a.ue-link-wrap {
        color: ${(p) => p.accentColorDark ? p.theme.palette.accent.dark[p.accentColor] : p.theme.palette.accent[p.accentColor]};
        white-space: nowrap;
        background-image: ${(p) =>
            getRadialGradient(
                p.theme.palette.gradient[p.accentColor].from,
                p.theme.palette.gradient[p.accentColor].to
            )};
        background-position: 0% 100%;
        background-repeat: no-repeat;
        background-size: 0% 2px;
        padding-bottom: 4px;
        margin-bottom: -4px;
        &:active {
            text-decoration: none;
        }
    }
    &.active a.ue-link-wrap {
        background-size: 100% 2px;
    }
    a.ue-link-wrap:hover {
        color: unset;
        animation: underline 1.8s infinite;
        @media (prefers-reduced-motion: reduce) {
            animation: none;
            background-size: 100% 2px;
        }
        @keyframes underline {
            0% {
                background-size: 10% 2px;
            }
            50% {
                background-size: 100% 2px;
            }
            100% {
                background-size: 100% 2px;
            }
        }
    }
`;

interface HyperlinkProps extends LinkProps {
    active?: boolean;
    component?: React.FunctionComponent<any> | 'a';
    accentColorDark?: boolean;
}

export const Hyperlink = ({accentColor = 'sky', accentColorDark,  active, ...rest}: HyperlinkProps): JSX.Element => (
    <HyperlinkWrapper className={`hlink-wrap ${active ? 'active' : ''}`} accentColor={accentColor} accentColorDark={accentColorDark}>
        <UeLink {...rest} />
    </HyperlinkWrapper>
);
